import { gql } from '@apollo/client';

export const GET_REMOVED_LISTINGS_AMOUNT_DISTRIBUTION = gql`
  query GetRemovedListingsAmountDistribution($filters: DistributionGraphsInput) {
    getRemovedListingsAmountDistribution(input: $filters) {
      amountOfRemovedListingsPerPeriod
      weekISO8601
    }
  }
`;
